import { render, staticRenderFns } from "./RelationFieldSearchDialog.vue?vue&type=template&id=00b0ccf4"
import script from "./RelationFieldSearchDialog.vue?vue&type=script&lang=js"
export * from "./RelationFieldSearchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports